/* istanbul ignore file */
import { useInvoiceUrl, useInvoiceId } from 'domain/finance/invoice/shared/useInvoiceRouting';
import { UPDATE_INVOICE } from 'domain/finance/invoice/useInvoiceService';
import { EditButton, EditButtonProps } from 'framework/ui/ui-builder';

const EditInvoiceButton = (props: EditButtonProps) => {
  const { getUpdateEntityUrl } = useInvoiceUrl();
  const id = useInvoiceId();

  return (
    <EditButton
      {...props}
      path={getUpdateEntityUrl(id)}
      key="edit-invoice"
      permissionToCheck={UPDATE_INVOICE}
      outline
      label="Edit document"
    />
  );
};

export default EditInvoiceButton;
